import { IS_LOADING, ERROR} from "../../constants";

export { IS_LOADING, ERROR }

export const SEARCH_PRODUCTS = "SEARCH_PRODUCTS";
export const SET_PRODUCT_CATEGORIES = "SET_PRODUCT_CATEGORIES";
export const SET_PRODUCT = "SET_PRODUCT";
export const SEARCH_PRODUCT_CATEGORIES = "SEARCH_PRODUCT_CATEGORIES";
export const SEARCH_PRODUCT_OF_SELECTED_CATEGORY = "SEARCH_PRODUCT_OF_SELECTED_CATEGORY";
export const SET_SELECTED_PRODUCT_DESIGNATION = "SET_SELECTED_PRODUCT_DESIGNATION";

export const SEARCH_LIMIT = 20;